import { Button, Container, Heading, Input, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
const ChangePassword = () => {
    const [oldpassword, setOldpassword] = useState('')
    const [newpassword, setNewpassword] = useState('')
  return (
    <Container py='16' minH={'90vh'}>
    <form >
      <Heading textTransform={'uppercase'} children="Change Password" my='16' textAlign={['center','left']}/>
      <VStack spacing={'8'}>
      <Input required id='password' value={oldpassword} onChange={(e)=>setOldpassword(e.target.value)} placeholder=' Old Password' type={'password'} focusBorderColor='yellow.500' />

      <Input required id='password' value={newpassword} onChange={(e)=>setNewpassword(e.target.value)} placeholder=' New Password' type={'password'} focusBorderColor='yellow.500' />
      <Button w='full' colorScheme={'yellow'} type='submit'>Change</Button>
      </VStack>
    </form>
  </Container>
  )
}

export default ChangePassword